var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    gradientUnits: "userSpaceOnUse",
    x1: "-5.19%",
    y1: "93.4%",
    x2: "105.19%",
    y2: "6.6%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    stopColor: "#7CEFA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    stopColor: "#8FD3F4"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7475 9.75V13.5M10.4493 3.74857L2.20155 17.9978C2.06957 18.2259 1.99997 18.4846 1.99976 18.748C1.99954 19.0115 2.06871 19.2703 2.20031 19.4986C2.3319 19.7268 2.52129 19.9163 2.7494 20.0481C2.97751 20.1799 3.23631 20.2493 3.49976 20.2493H19.9953C20.2588 20.2493 20.5176 20.1799 20.7457 20.0481C20.9738 19.9163 21.1632 19.7268 21.2948 19.4986C21.4264 19.2703 21.4955 19.0115 21.4953 18.748C21.4951 18.4846 21.4255 18.2258 21.2935 17.9978L13.0457 3.74857C12.914 3.52093 12.7247 3.33193 12.4968 3.20055C12.269 3.06916 12.0106 3 11.7475 3C11.4845 3 11.2261 3.06916 10.9982 3.20055C10.7704 3.33193 10.5811 3.52093 10.4493 3.74857Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7478 18C12.3691 18 12.8728 17.4963 12.8728 16.875C12.8728 16.2537 12.3691 15.75 11.7478 15.75C11.1265 15.75 10.6228 16.2537 10.6228 16.875C10.6228 17.4963 11.1265 18 11.7478 18Z",
    fill: "current"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.148a5ed3bbc276827d1bd15e26004330.svg";
export { ForwardRef as ReactComponent };